<div class="apple-card">
  <div class="apple-card-header">
    <div class="apple-card-icon">
      <mat-icon>person</mat-icon>
    </div>
    <div class="apple-card-title-section">
      <h3>Kontakt</h3>
    </div>
  </div>
  <div class="apple-card-content" *ngIf="contact$ | async as contact">
    <div class="apple-info-row" *ngIf="contact.firstName || contact.lastName">
      <span class="apple-info-label">Name</span>
      <span class="apple-info-value">{{ contact.firstName }} {{ contact.lastName }}</span>
    </div>
    <div class="apple-info-row" *ngIf="contact.email">
      <span class="apple-info-label">E-Mail</span>
      <span class="apple-info-value">{{ contact.email }}</span>
    </div>
    <div class="apple-info-row" *ngIf="contact.callThrough">
      <span class="apple-info-label">Durchwahl</span>
      <span class="apple-info-value">{{ contact.callThrough }}</span>
    </div>
    <div class="apple-info-row" *ngIf="contact.mail">
      <span class="apple-info-label">Email</span>
      <span class="apple-info-value">{{ contact.mail }}</span>
    </div>
  </div>
</div>
